import axios from 'Src/helpers/api/axiosInstance';

export function checkAvailability(data) {
  return axios.post(`${window.apiBase}/public/register/check`, data).then(response => {
    return response.data;
  });
}
